import { gql } from '@apollo/client';

export const USER_WORK_LOCATIONS_QUERY = gql`
  query userWorkLocations {
    userWorkLocations {
      dealerId
      workLocationId
      name
    }
  }
`;
